<div class="ab-list-item-inner flex w-100 activity-type--upload">
  <span class="ab-list-item__icon">
    <span class="ab-fa-stacked--v2">
      <i class="icon fal fa-pen-to-square ab-stacked-icon"></i>
      <i class="icon fal fa-arrows-up-down-left-right ab-stacked-icon with-shadow--white"></i>
    </span>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">

      <span class="actor">{{item?.user?.name}}</span>
      <span> added <strong>{{payload.entitiesAffected}}</strong> entities from this campaign to </span>
      <strong>{{campaignName}}</strong>

      <span> using bulk edit.</span>

    </div>
  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
